import React, { useEffect, useState } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import useAccountTypeName from '../../hooks/useAccountTypeName'
import { envAwarePost } from '../../util/util';
import { 
    getAllClients,
    getAllTrainers,
    selectAllClients,
    selectAllTrainers,
    showProspects,
    selectTrainersById,
    deleteClient 
} from '../users/usersSlice';
import Spinner from 'react-bootstrap/Spinner'
import classes from './Clients.module.css'
import { capitalize} from '../../util/util'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch';
import ProspectViewer from '../ProspectViewer/ProspectViewer'

function Clients() {

    const dispatch = useDispatch()
    const [data, setData] = useState([])
    const user = useSelector(state => state.users.current_user)
    const resolvedClientAccountName = useAccountTypeName('client')
    const resolvedGymAccountName = useAccountTypeName('gym')
    const [trainers, setTrainers] = useState([])
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteId, setDeleteId] = useState()
    const [gymId, setgymId] = useState()
    const [searchTerm, setSearchTerm] = React.useState("");
    const [clientLoading, setClientLoading] = useState(false)

    let statusDispatch = useApiStatusDispatch();

    const handleChange = event => {
        setSearchTerm(event.target.value);
    };

    const trainersData = useSelector(selectAllTrainers)

    const clientsData = useSelector(selectAllClients)


    useEffect(() => {
        setClientLoading(true)
        envAwarePost('api/users/api.php', {
            action: 'getAllClients',
        }).then((res) => {
            setData(res.data)
            setClientLoading(false)
        })
        dispatch(getAllTrainers())
    }, [deleteModal])



    const handleDeleteClient = (id, gymId) => {
        setDeleteModal(true)
        setDeleteId(id)
        setgymId(gymId)
    }

    const deleteValue = (id) => {
        statusDispatch(deleteClient(deleteId), "client", "delete")
        .then(res => {
            setDeleteModal(false)
        }).catch(err => {
            console.log("Error:-", err)
        })
    }

    const TrainerData = ({ trainerId }) => {
        const trainer = useSelector(state => selectTrainersById(state, trainerId))
        if (trainer) {
            return trainer.user_name
        } else if (trainerId == user.gym_id) {
            return "Shared"
        } else {
            return ("Not Assigned")
        }
    }


    return (
        <div className="pt-2 px-2 px-md-3">
            <div>
                <div>
                    <strong className="d-block mb-1">
                        All {capitalize(resolvedClientAccountName)}s ({clientsData && data?.length} total)
                    </strong>
                    <div className={classes.addNewClients}>
                        <Button
                            as={Link}
                            to="/growth"
                            variant="outline-info"
                            size="sm"
                            className="mr-2 mb-2"
                        >
                            <i className="far fa-user"></i> Prospective {capitalize(resolvedClientAccountName)}s
                        </Button>
                        <Link to="/add-client"><Button variant="outline-success" size="sm">Add new {resolvedClientAccountName}</Button></Link>
                    </div>
                    <div className={classes.searchClient}>
                        <input
                            type="email"
                            class="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Search for a specific Client's Name in the list below..."
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>Client Name</th>
                                    <th>Trainer Name</th>
                                    <th>Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                {clientLoading ? <Spinner animation="border" variant="primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner> :
                                    data && data.filter((event) => event.user_name.toLowerCase().includes(searchTerm.toLowerCase())).map((client) => (
                                        <tr>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <img 
                                                        class="rounded-circle profilePic" 
                                                        src={client.profile_pic ? client.profile_pic : "https://cdn.fitsw.com/assets/img/defaultProfile.png"} 
                                                        alt={client.user_name} height="32" width="32"
                                                    />
                                                    <Link  
                                                        to={`/clientEditor/?clientId=${client.user_id_number}`} 
                                                        className="ml-1"
                                                    >
                                                        {client.user_name}
                                                    </Link>
                                                </div>
                                            </td>
                                            <td style={{maxWidth:'100px'}}>
                                                <TrainerData trainerId={client.user_trainer_id} style={{maxWidth:'100px'}}/>
                                            </td>
                                            <td><Button onClick={(e) => handleDeleteClient(client.user_id_number, client.gym_id)} variant="danger" size="sm">Delete</Button></td>
                                        </tr>
                                    ))}
                            </tbody>
                        </Table>
                        <Modal
                            size="lg"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            show={deleteModal}
                        >
                            <Modal.Header>
                                <Modal.Title id="contained-modal-title-vcenter">
                                    Delete Client
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body class="text-center" >
                                <h4></h4>
                                <p>
                                    Are You Sure?
                                </p>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setDeleteModal(false)}>Cancel</Button>
                                <Button onClick={deleteValue} variant="danger">Delete</Button>
                            </Modal.Footer>
                        </Modal>
                        <ProspectViewer/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Clients
